var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDashboardLow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 16.0001C2.66602 8.63628 8.63555 2.66675 15.9993 2.66675C23.3631 2.66675 29.3327 8.63628 29.3327 16.0001C29.3327 17.4811 29.0912 18.9058 28.6455 20.2369C28.4712 20.0891 28.2456 20.0001 27.9993 20.0001H16.6055L12.8859 12.8709C12.6305 12.3812 12.0264 12.1914 11.5368 12.4468C11.0471 12.7023 10.8573 13.3063 11.1128 13.7959L14.3497 20.0001H3.99935C3.75303 20.0001 3.52751 20.0891 3.35323 20.2369C2.9075 18.9058 2.66602 17.4811 2.66602 16.0001Z",
    fill: "#DB443A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08789 22C6.28364 26.3501 10.7925 29.3333 15.9981 29.3333C21.2039 29.3333 25.7127 26.3501 27.9084 22H4.08789Z",
    fill: "#DB443A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardLow);
export default __webpack_public_path__ + "static/media/icon_dashboard_low.3efd7b2f98395056e749ebaa44608bf5.svg";
export { ForwardRef as ReactComponent };